import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './style';
import Button from 'storybookComponents/Button';
import { Formik, Form } from 'formik';
import Stepper from 'storybookComponents/Stepper';
import createEvent from "relay/event/mutations/createEvent"
import updateEvent from "relay/event/mutations/updateEvent"
import updateEmailTemplate from "relay/event/mutations/updateEmailTemplate"
import approveEvent from "relay/event/mutations/approveEvent"
import disapproveEvent from "relay/event/mutations/disApproveEvent"
import toggleEmails from "relay/event/mutations/toggleEmails"
import environment from "environments/environment.js"
import { getEventTemplateFields } from "relay/event"
import { hasPendingChanges, getDefaultValues, updateStepper, parseEventPayload, parseDateToPropertyTimezone, parseDateToString, brToNl } from "./util/index"
import EventVenue from './EventVenue';
import Preview from './OmnichannelPreview';
import ScheduleEvent from "./ScheduleEvent"
import ToastMessage from "storybookComponents/Toast"
import CircularProgress from '@material-ui/core/CircularProgress';
import { getEditEventPath, getEventRoutesParameters, PREVIEW, SCHEDULE, PUBLISH, getAppPath } from "constants/path";
import * as apis from "relay/event";
import { getPropertyId, shouldDoApprove, getOrgId } from "common"
import publishEvent from "relay/event/mutations/publishEvent.js"
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";
import SwipeableViews from 'react-swipeable-views';
import Confirm from "components/Confirm";
import InfoComponent from "components/InfoComponent"
import UserContext from 'context/UserContext';
import Switch from 'components/Switch/simpleSwitch'

const dangerButtonStyle = { margin: 10 }

const STEPS = {
  [PREVIEW]: 1,
  [PUBLISH]: 2,
  [SCHEDULE]: 2
}


// var emailInput = {}
// var confirmEmail = {}
// var thankYouEmail = {}
var currentFormValues = {}
const Event = withStyles(styles)(({ classes, history, isDrawerOpen, toggleDrawer, username, isApprover: userIsApprover, settings: approverSettings, loadingSetting, setTitle, orgLevel, setOriginNavItems, showNotification, isNotificationsBarVisible, ...props }) => {
  let { id, step: _step } = getEventRoutesParameters();
  const { subOrgDetails } = React.useContext(UserContext);
  const orgColors = {
    buttonBackgroundColor: subOrgDetails.buttonBackgroundColor,
    buttonBorderColor: subOrgDetails.buttonBorderColor,
    buttonFontColor: subOrgDetails.buttonFontColor,
    fontFamily: subOrgDetails.fontFamily,
    id: subOrgDetails.id,
    linkColor: subOrgDetails.linkColor,
    textColor: subOrgDetails.textColor,
  }
  const [isActive, setActive] = React.useState("active");
  const [draftEvent, setDraftEvent] = React.useState(getDefaultValues({ ...props, name:subOrgDetails.name,  address: subOrgDetails.address, timezoneString: subOrgDetails.timezoneString }));
  const [initialValues, setInitialValues] = React.useState(getDefaultValues({ ...props, name:subOrgDetails.name, address: subOrgDetails.address, timezoneString: subOrgDetails.timezoneString }))
  const [loading, setLoading] = React.useState(false);
  const [step, setStep] = React.useState()
  const [steps, updateSteps] = React.useState([])
  const [scheduleInput, setScheduleInput] = React.useState();
  const [inviteTemplate, setInviteTemplate] = React.useState({});
  // const [confirmEmailTemplate, setConfirmEmailTemplate] = React.useState({});
  // const [thankYouEmailTemplate, setThankYouEmailTemplate] = React.useState({});
  const [needToApprove, setNeedToApprove] = React.useState(shouldDoApprove(draftEvent));
  const [disapproveConfirm, setDisapproveConfirm] = React.useState(false)
  const [approveConfirm, setApproveConfirm] = React.useState(false)
  const [error, setError] = React.useState(null);
  const [activePreviewTab, setActivePreviewTab] = React.useState()
  // const [pdfFileName, setPdfFileName] = React.useState();
  const [smsConfirmationText, setSMSConfirmationText] = React.useState(null);
  const [hylyFormFields, setHylyFormFields] = React.useState()
  const [eventLoading, setEventLoading] = React.useState(false)

  const onCancel = () => {
    history.push(getAppPath())
    // window.location.replace(getAppPath())
  }

  const getEditableFields = async (editorId, type) => {
    try {
      let hyblastEditorResponse = await getEventTemplateFields(editorId)
      if (hyblastEditorResponse && hyblastEditorResponse.hyblastEditor) {
        // if (type === "invite") {
        setInviteTemplate(hyblastEditorResponse.hyblastEditor)
        // } else if (type === "confirm") {
        //   setConfirmEmailTemplate(hyblastEditorResponse.hyblastEditor)
        // } else if (type === "thankyou") {
        //   setThankYouEmailTemplate(hyblastEditorResponse.hyblastEditor)
        // }
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const getCreatedEventData = async (event) => {
    try {
      setTitle([
        {
          label: "Events",
          to: getAppPath()
        },
        {
          label: event.title,
          to: "/"
        }
      ])
      getEditableFields(event.inviteEmailCampaignId, "invite")
      //getEditableFields(event.rsvpedCampaignId, "confirm")
      //getEditableFields(event.thankYouCampaignId, "thankyou")

      setDraftEvent({ ...event, docData: event.document && event.document.fileUrl, imageData: event.image.fileUrl, ...parseDateToPropertyTimezone(event, subOrgDetails.timezoneString) });
      // if (event.document) {
      //   setPdfFileName(event.document.name)
      // } else {
      //   setPdfFileName('')
      // }
      setInitialValues({ ...event, docData: event.document && event.document.fileUrl, imageData: event.image.fileUrl, ...parseDateToPropertyTimezone(event, subOrgDetails.timezoneString) })
      updateSteps(updateStepper(STEPS[_step] || 0, event.status))
      setNeedToApprove(shouldDoApprove(event))
    } catch (err) {
      console.log("err :", err)
    }
  }

  const loadLeadFields = async () => {
    try {
      let response = await apis.getLeadFields(getPropertyId());
      if (response.leadFields) {
        setHylyFormFields(response.leadFields);
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const initLoad = async (id) => {

    try {
      const response = await apis.getEvent(id);
      const event = response.hyevent;
      if (event) {
        await getCreatedEventData(event)
      } else {
        updateSteps(updateStepper(0))
      }

      setError(null);
    }
    catch (error) {
      console.log("event error : ", error)
      setError("Something went wrong. Please try later.")
      setLoading(false)
    }
  }

  const init = async () => {
    try {
      setLoading(true)
      await loadLeadFields();
      if (id) {
        await initLoad(id)
      } else {
        setTitle([
          {
            label: "Events",
            link: getAppPath() + "/events",
          },
          {
            label: "Create New",
            to: "/",
          },
        ]);
      }
      setLoading(false);
    } catch (err) {
      console.log("err", err);
    }
  }

  useEffect(() => {
    setStep(STEPS[_step] || 0)
    updateSteps(updateStepper(STEPS[_step] || 0))
    init()
    if (isDrawerOpen) {
      toggleDrawer();
    }
    setOriginNavItems(orgLevel);
  }, [1])

  useEffect(() => {
    window.parent.smsEditorInputChange = (type, field, value) => {
      // if (type == "invite") {
      //   emailInput[field] = value;
      // } else if (type == "confirm") {
      //   confirmEmail[field] = value;
      // } else if (type == "thankyou") {
      //   thankYouEmail[field] = value;
      // } else {
      setSMSConfirmationText(value)
      // }
    }
    window.parent.br2nl = function (str, replaceMode) {
      var replaceStr = replaceMode ? "\n" : "";
      // Includes <br>, <BR>, <br />, </br>
      return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
    };

  }, [1])

  const onPublishSuccess = (date, event) => {
    if (!userIsApprover) {
      showNotification(`Your event has been successfully sent for approval and would be published once approved.`, "success")
    }
    else {
      showNotification(`Event ${event.title} is scheduled for publish successfully. Your contacts can view and RSVP once event is published`, "success")
    }
    setDraftEvent({ ...draftEvent, ...event, ...parseDateToPropertyTimezone(event, subOrgDetails.timezoneString) });
  }

  const onScheduleSuccess = (date, event) => {
    setDraftEvent({ ...draftEvent, ...event.hyevent, ...parseDateToPropertyTimezone(event.hyevent, subOrgDetails.timezoneString) });
    showNotification(`Invite for ${event.hyevent.title} is scheduled successfully.You can edit the schedule date & time before ${date}.`, "success")
  }


  const onSave = async (values, preventTabChange) => {
    try {
      setActive("inactive");
      let result;
      if (id) {
        let payload = parseEventPayload(values, id, draftEvent.imageData !== values.imageData, draftEvent.docData !== values.docData);
        payload.smsConfirmationText = smsConfirmationText;
        if (draftEvent.status === "published" || draftEvent.status === "invited" || draftEvent.status === "invite_scheduled") {
          delete payload.startAt;
          delete payload.endAt;
          delete payload.address;
          delete payload.placeName;
          delete payload.passcode;
          delete payload.zoomLink;
          delete payload.meetingId;
          delete payload.eventType;
          delete payload.displayTime;
          result = await updateEvent(environment, payload);
        } else {
          result = await updateEvent(environment, payload);
        }

      } else {
        setEventLoading(true)
        result = await createEvent(environment, parseEventPayload({
          ...values, propertyId: getPropertyId(),
        }, id));
      }

      if (result.createHyevent || result.updateHyevent) {
        if (!id) {
          id = result.createHyevent.hyevent.id;
          _step = "preview";
          setStep(1);
          await getCreatedEventData(result.createHyevent.hyevent);
          setEventLoading(false)

          showNotification(`Event ${values.title} is created successfully. Preview and publish the event for your contacts to see it.`, "success");

          window.history.pushState(
            {},
            null,
            window.location.pathname + "/" + result.createHyevent.hyevent.id
          )
        } else {
          setTitle([
            {
              label: "Events",
              link: getAppPath() + "/events",
            },
            {
              label: values.title,
              to: "/",
            },
          ]);
          if (!preventTabChange) {
            showNotification(
              `Event ${values.title} is updated successfully. Your contacts will see the latest update if event is published. Publish event if not yet done.`,
              "success"
            );
          }
          let event = result.updateHyevent.hyevent;
          setDraftEvent({ ...draftEvent, ...event, docData: event.document && event.document.fileUrl, imageData: event.image.fileUrl, ...parseDateToPropertyTimezone(event, subOrgDetails.timezoneString) });
          // if (event.document) {
          //   setPdfFileName(event.document.name)
          // } else {
          //   setPdfFileName('')
          // }
          if (preventTabChange) return
          updateSteps(updateStepper(1, event.status))
          setStep(1)
        }
      } else {
        setEventLoading(false)
        const uncatchableError = getErrorMessage(checkUncatchableError(id ? "updateEventMutation" : "createEventMutation"));
        console.log("error: ", error)
        showNotification(uncatchableError || `Something went wrong`, "error")
      }
    } catch (error) {
      setEventLoading(false)
      const uncatchableError = getErrorMessage(checkUncatchableError(id ? "updateEventMutation" : "createEventMutation"));
      console.log("error: ", error)
      showNotification(uncatchableError || `Something went wrong`, "error")
    }
    setActive("active");
  }

  const onPublish = async (publishInput) => {
    try {
      if (id) {
        setActive("inactive");
        let result = await publishEvent(environment, publishInput);
        if (result.publishHyevent) {
          onPublishSuccess(parseDateToString(publishInput.publishDate, subOrgDetails.timezoneString), result.publishHyevent.hyevent);
          setActive("active");
        } else {
          const uncatchableError = getErrorMessage(checkUncatchableError("publishEventMutation"));
          if (uncatchableError) {
            showNotification(uncatchableError, "error");
          }
          setActive("active");
        }
      }
    }
    catch (error) {
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
    }
  }

  const onPublishCallBack = (publishInput) => {
    let currentDate = new Date();
    let selectedDate = new Date(publishInput.publishDate);
    selectedDate.setSeconds(0);
    if (currentDate > selectedDate) {
      onPublish({
        ...publishInput,
        publish: "now"
      })
    } else {
      onPublish(publishInput)
    }
  }

  const onSchedule = async () => {
    try {
      setActive("inactive");
      const res = await apis.scheduleEvent(scheduleInput);
      if (res.scheduleInviteHyevent) {
        onScheduleSuccess(parseDateToString(scheduleInput.inviteScheduleAt, subOrgDetails.timezoneString), res.scheduleInviteHyevent)
        setActive("active");
      }

      else {
        const uncachebleError = getErrorMessage(checkUncatchableError("scheduleEventMutation"));
        if (uncachebleError) {
          showNotification(uncachebleError, "error");
        }
        setActive("active");
      }
    }
    catch (error) {
      setActive("active");
      showNotification("Something went wrong", "error");
      console.log("error: ", error)
    }
  }

  const onApprove = async (save) => {
    try {
      setActive("inactive");
      let response = await approveEvent({ id });
      if (response.approveHyevent) {
        if (!save) {
          showNotification(`You have successfully approved ${draftEvent.title}.`);
        } else {
          showNotification(
            `You have successfully saved the changes and approved ${draftEvent.title}.`
          );
        }
        if (typeof props.saveRecentAccessed == "function") {
          props.saveRecentAccessed("editor", "Event", null, id);
        }
        setNeedToApprove(false);
        setTimeout(() => {
          history.push(getAppPath() + "/event/" + id);
        }, 5000);
      } else {
        const uncatchableError = getErrorMessage(checkUncatchableError("approveEventMutation"));
        if (uncatchableError) {
          showNotification(uncatchableError, "error");
        }
      }
      setActive("active");
    } catch (err) {
      console.log("err: ", err);
      showNotification("Something went wrong", "error");
      setActive("active");
    }
  }

  const onDisapprove = async (feedback, save) => {
    try {
      setActive("inactive");
      let response = await disapproveEvent({
        id,
        disapproveReason: feedback,
      });
      if (response.disapproveHyevent) {
        if (save) {
          showNotification(
            `You have successfully saved the changes and disapproved ${draftEvent.title} and the feedback has been sent to the agent.`,
            "success"
          );
        } else {
          showNotification(
            `You have successfully disapproved ${draftEvent.title} and the feedback has been sent to the agent.`,
            "success"
          );
        }
        setNeedToApprove(false);
        setDraftEvent({
          ...draftEvent,
          approverName: username,
          disapproveReason: feedback,
        });
        if (typeof props.saveRecentAccessed == "function") {
          props.saveRecentAccessed("editor", "Event", null, id);
        }
        setTimeout(() => {
          history.push(getAppPath() + "/event/" + id);
        }, 5000);
      } else {
        const uncatchableError = getErrorMessage(
          checkUncatchableError("disApproveEventMutation")
        );
        if (uncatchableError) {
          showNotification(uncatchableError, "error");
        }
      }
      setActive("active");
    } catch (err) {
      const uncatchableError = getErrorMessage(checkUncatchableError("disApproveEventMutation"));
      if (uncatchableError) {
        showNotification(uncatchableError, "error");
      }
      setActive("active");
    }
  };

  const changeStep = (index) => {
    if (!id && index >= 1) return;
    if (draftEvent.status === "draft" && index === 3) return;
    setActive("active");
    setStep(index)
    updateSteps(updateStepper(index, draftEvent.status))
  }

  const getSubmitButtonState = (type) => {
    if (needToApprove && userIsApprover) return isActive;
    switch (step) {
      case 0: return isActive
      case 1:
        return (isActive === "inactive") ? "inactive" : "active";
      case 2:
        if (type === "publish") {
          return isActive === "active" ? "active" : "inactive";
        }
        if (type === "schedule") {
          return scheduleInput && scheduleInput.invitedGroups && scheduleInput.id && scheduleInput.inviteScheduleAt && isActive === "active" ? "active" : "inactive"
        }

        return "inactive"
    }
  }


  const getButtonText = (step) => {
    if (needToApprove && userIsApprover) return "Approve"
    switch (step) {
      case 0:
        return "Save & Next";
      case 1:
        return (activePreviewTab === "disable") ? "Next" : "Save";
      default: return ""
    }
  }



  const onPreviewSave = (values) => {
    if (activePreviewTab === "disable") {
      changeStep(2)
    } else {
      onSave(values)
    }
  }


  const onSubmit = (values) => {
    if (needToApprove && userIsApprover) {
      if (
        hasPendingChanges(
          parseEventPayload(
            values,
            id,
            draftEvent.imageData !== values.imageData,
            draftEvent.docData !== values.docData
          ),
          draftEvent
        )
      ) {
        return setUnsavedMode("Approve");
      }
      return toggleApproveConfirm();
    }
    switch (step) {
      case 0:
        return onSave(values);
      case 1:
        return onPreviewSave(values);
      case 2:
        return onPublish();
      case 3:
        return onSchedule();
      default:
        return "";
    }
  };

  const beforeDisapprove = () => {
    if (
      hasPendingChanges(
        parseEventPayload(
          currentFormValues,
          id,
          draftEvent.imageData !== currentFormValues.imageData,
          draftEvent.docData !== currentFormValues.docData
        ),
        draftEvent
      )
    ) {
      return setUnsavedMode("Disapprove");
    }
    return toggleDisapproveConfirm();
  };

  const toggleDisapproveConfirm = () => {
    setDisapproveConfirm(!disapproveConfirm);
  }

  const toggleApproveConfirm = () => {
    setApproveConfirm(!approveConfirm);
  }

  const onSaveAndApprove = async () => {
    await onSave(currentFormValues, true);
    onApprove(true);
  };
  const onSaveDisapprove = async (feedback) => {
    await onSave(currentFormValues, true);
    onDisapprove(feedback, true);
  };

  const closeUnsaved = () => {
    setUnsavedMode("")
  }

  const onVenuePopupStateChange = (open) => {
    setActive(open ? "inactive" : "active")
  }

  const handleToggleEmails = async (toggle, prev, name, key) => {
    try {
      let response = await toggleEmails({
        id: draftEvent.id, [key]: toggle
      });
      if (response && response.toggleHyeventEmails) {
        let active = response.toggleHyeventEmails.hyevent[key];
        showNotification(`${name} email for ${draftEvent.title} is ${active ? 'activated' : 'deactivated'} successfully`, "success");
        setDraftEvent({ ...draftEvent, [key]: active });
        return active;
      }
      else {
        const uncachebleError = getErrorMessage(checkUncatchableError("toggleEmailsMutation"));
        showNotification(uncachebleError || `Something went wrong`, "error");
        return prev;
      }
    } catch (err) {
      const uncachebleError = getErrorMessage(checkUncatchableError("toggleEmailsMutation"));
      showNotification(uncachebleError || `Something went wrong`, "error");
      return prev;
    }
  }


  const [unsavedMode, setUnsavedMode] = React.useState("");

  const handleApproveDisapproveToggle = () => {
    if (disapproveConfirm) {
      toggleDisapproveConfirm();
    } else if (approveConfirm) {
      toggleApproveConfirm();
    } else {
      closeUnsaved();
    }
  };

  const customActionForUnsavedCancel = (feedback) => {
    if (unsavedMode === "Approve") {
      onApprove();
    } else {
      onDisapprove(feedback);
    }
    closeUnsaved();
    setApproveConfirm(false);
    setDisapproveConfirm(false);
  };

  const handleActionOfApproveDisapprove = (feedback) => {
    if (disapproveConfirm) {
      onDisapprove(feedback);
    } else if (approveConfirm) {
      onApprove();
    } else {
      if (unsavedMode === "Approve") {
        onSaveAndApprove();
      } else {
        onSaveDisapprove(feedback);
      }
    }
    closeUnsaved();
    setApproveConfirm(false);
    setDisapproveConfirm(false);
  };
  const renderModalMessage = () => {
    if (disapproveConfirm) {
      return (
        <div>
          <div>
            Are you sure, you want to disapprove the <strong>{draftEvent.title}</strong> event
            request ?
          </div>
          <div className={classes.bottomText}>
            Please write your feedback below that goes to the Agent
          </div>
        </div>
      );
    } else if (approveConfirm) {
      return (
        <div>
          Are you sure, you want to approve <strong>{draftEvent.title}</strong> event request?
        </div>
      );
    } else {
      if (unsavedMode === "Approve") {
        return (
          <div>
            It seems there are some unsaved changes in the event. Do you wish to save or discard
            changes before you approve <strong>{draftEvent.title}</strong> event request?
          </div>
        );
      } else {
        return (
          <div>
            <div>
              It seems there are some unsaved changes in the event. Do you wish to save or discard
              changes before you disapprove <strong>{draftEvent.title}</strong> event request?
            </div>
            <div className={classes.bottomText}>
              Please write your feedback below that goes to the Agent
            </div>
          </div>
        );
      }
    }
  };

  const renderForm = (form_props) => {
    currentFormValues = form_props.values
    return (
      <Form className={classes.form}>
        <div className={classes.mainHeader}>
          <Stepper allSteps={steps} onStepCLickedCallback={changeStep} /> {/* TODO: stpes should be checked for stepper bug */}
          <div className={classes.headerRight}>

            {step !== 2 ? <InfoComponent {...draftEvent} /> : null}
            {/* {
              (step == 1 && activePreviewTab == "thankYouEmailHtml") ?
                <>
                  <div className={classes.emailText}>
                    Email:
                  </div>
                  <Switch
                    toggled={draftEvent.enableThankYouEmail}
                    onToggle={handleToggleEmails}
                  /> 
                  <div className={classes.divider}></div>
                </> : null
            } */}
            {
              step !== 2 ? (
                <Button state={isActive} variant="tertiary" size="sm" onClick={onCancel}>
                  Cancel
                </Button>
              ) : null}
            {needToApprove && userIsApprover ? (
              <Button
                className={classes.headerButtonStyle}
                state={isActive}
                variant="secondary"
                negative={true}
                size="sm"
                onClick={beforeDisapprove}
              >
                Disapprove
              </Button>
            ) : null}
            {step !== 2 || (needToApprove && userIsApprover) ? (
              <Button
                className={classes.headerButtonStyle}
                state={getSubmitButtonState()}
                color="hylyBlue"
                type="submit"
                variant="primary"
                size="sm"
              >
                {getButtonText(step)}
              </Button>
            ) : null
            }

          </div>
        </div>
        {
          (eventLoading) ?
            <div className={`${classes.loader} ${classes.loaderCustom}`}><CircularProgress className={classes.colorPrimary} /></div> :
            <div className={`${classes.root} ${isNotificationsBarVisible && classes.customRoot}`} >
              {step === 0 && <EventVenue hylyFormFields={hylyFormFields}
                //setPdfFileName={setPdfFileName} 
                {...draftEvent} form_props={form_props} id={id} showNotification={showNotification} onCancel={onCancel} poupStateChange={onVenuePopupStateChange}
              //pdfFileName={pdfFileName}
              />}
              {step === 1 && <Preview setActivePreviewTab={setActivePreviewTab}  {...draftEvent} id={id} showNotification={showNotification} isDrawerOpen={isDrawerOpen} onCancel={onCancel} orgColors={orgColors} handleToggleEmails={handleToggleEmails} timezoneString={subOrgDetails.timezoneString} username={username} />}
              {step === 2 && <ScheduleEvent {...draftEvent} onChange={setScheduleInput} showNotification={showNotification} {...inviteTemplate} id={id} username={username} userIsApprover={userIsApprover} approverSettings={approverSettings} getSubmitButtonState={getSubmitButtonState} onPublish={onPublishCallBack} onScheduleSMSEmail={onSchedule} timezoneString={subOrgDetails.timezoneString} timezoneAbbr={subOrgDetails.timezoneAbbr} />}
            </div>
        }
      </Form >
    )
  }


  if (loading || loadingSetting) return <div className={classes.loader}><CircularProgress className={classes.colorPrimary} /></div>
  if (error) return <div className={classes.loader}>{error}</div>
  return (
    <div className={classes.superContainer}>
      <Formik
        initialValues={draftEvent}
        enableReinitialize={true}
        onSubmit={onSubmit}
      >
        {renderForm}
      </Formik>
      <Confirm
        title={
          disapproveConfirm
            ? "Disapprove Event Request"
            : approveConfirm
              ? "Approve Event Request"
              : `${unsavedMode} Event Request`
        }
        open={disapproveConfirm || approveConfirm || unsavedMode}
        toggler={handleApproveDisapproveToggle}
        customAction={unsavedMode ? customActionForUnsavedCancel : null}
        cancelText={unsavedMode ? `${unsavedMode} Without Save` : "Cancel"}
        actionText={
          disapproveConfirm
            ? "Yes, disapprove"
            : approveConfirm
              ? "Yes, Approve"
              : `Save and ${unsavedMode}`
        }
        message={renderModalMessage}
        action={handleActionOfApproveDisapprove}
        reason={approveConfirm || unsavedMode === "Approve" ? false : true}
        customVariant={approveConfirm || unsavedMode === "Approve" ? "Primary" : false}
      />
    </div >
  )
})

const unSaveDialogText = {
  Approve: {
    title: ""
  }
}

Event.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  dateTime: PropTypes.string,
  body: PropTypes.string,
};

Event.defaultProps = {
  title: `Valentine's Day Party`,
  subtitle: "LET'S CELEBRATE",
  dateTime: `Feb 14 2021, 7:30PM - 9:30PM`,
  message: `Roses are red,<br/>Violets are blue,<br/>We love having Residents,<br/>Just Like You!<br/><br/>Stop by the leasing office for cookies, chocolate, and ice cream. Let us know you are coming. RSVP.<br/><br/>See you there!`
};

export default Event;
